var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('wrapper', {
    staticClass: "h-40",
    attrs: {
      "left": _vm.left,
      "center": _vm.center,
      "right": _vm.right
    }
  }, [_c('a', {
    attrs: {
      "href": "https://apps.apple.com/us/app/spoferan/id1546584648",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('cdn-image', {
    attrs: {
      "src": "logos/badges/apple/download-app-store-black.svg",
      "size": {
        width: 120,
        ratio: 120 / 40
      },
      "alt": "Laden im App Store"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.spoferan.app",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('cdn-image', {
    attrs: {
      "src": "logos/badges/google/download-google-play.png",
      "size": {
        width: 154,
        ratio: 646 / 250
      },
      "max-width": 646,
      "alt": "Laden im Google Play Store"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }